/**
 * Shows the user a spinner with a message whilst they are waiting.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import spin from 'imported-assets/img/spin.svg';

export const Wait = ({ message, transparent, visible, fadeIn, fadeOut, onClick, children }) => (
    <div>
        <div
            className={classNames('waiting-message-screen-background', {
                transparent: transparent,
                invisible: !visible,
                'fade-in': fadeIn,
                'fade-out': fadeOut,
            })}
        />
        <div
            className={classNames('waiting-message-screen', {
                invisible: !visible,
                'fade-in': fadeIn,
                'fade-out': fadeOut,
            })}
            onClick={onClick}
        >
            <div className="waiting-message-screen-box">
                <img src={spin} />
                <div className="waiting-message-screen-message">
                    {message || children || 'Please Wait...'}
                </div>
            </div>
        </div>
    </div>
);

/**
 * - message - the text that is displayed by the loading indicator
 * - transparent - makes the loading overlay partially transparent
 * - visible - whether to show the message or not
 * - fadeIn - whether to fade the wait in
 * - fadeOut - whether to fade the wait out
 * - onClick - a function to fire on touch/click
 * - children - a custom message can be supplied
 */
Wait.propTypes = {
    message: PropTypes.string,
    transparent: PropTypes.bool,
    visible: PropTypes.bool,
    fadeIn: PropTypes.bool,
    fadeOut: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.node,
};

Wait.displayName = 'Wait';

export default Wait;
